<template>
  <div>
    <b-card>
      <b-row class="mt-1 mb-1">
        <b-col xl="2" lg="3" md="4" cols="12" v-if="rights.add">
          <b-dropdown
            v-if="reportDomain == 'myskoolhpgs'"
            variant="primary"
            block
            split
            right
            @click="Edit(0)"
          >
            <template #button-content>
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{$t('Journal')}}</span>
            </template>
            <b-dropdown-item :to="{ name: 'accounting-club-entry' }">
              {{$t('Club Entry')}}
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            v-else
            @click="Edit(0)"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1 mb-md-0"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{$t('Journal')}}</span>
          </b-button>
        </b-col>

        <b-col xl="4" lg="4" md="8" cols="12" class="mb-1 mb-lg-0">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-input-group-prepend
                is-text
                @click="LoadSearch()"
                class="cursor-pointer"
              >
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model.trim="searchQuery"
                :placeholder="$t('Search') + '...'"
                @keyup.enter="LoadSearch()"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col xl="2" lg="2" md="4" cols="12" class="p-lg-0">
          <b-form-group
            label=""
            :invalid-feedback="$t('Status is required')"
            ref="status"
            class=""
          >
            <v-select
              ref="status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="statusOptions"
              :reduce="(opt) => opt.value"
              label="text"
              v-model="filterStatus"
              :placeholder="$t('Select filter')"
              @input="setStatus()"
            />
          </b-form-group>
        </b-col>

        <b-col
          xl="4"
          lg="3"
          md="8"
          cols="12"
          class="d-md-flex align-items-start"
        >
          <b-form-group
            label=""
            :invalid-feedback="$t('Date is required')"
            ref="fil_date"
            class="mb-1 mb-md-0 mr-md-1"
          >
            <flat-pickr
              ref="fil_date"
              v-model="searchDate"
              :config="config"
              class="form-control"
              :placeholder="$t('Filter by date')"
              @on-change="setDate"
            />
          </b-form-group>
          <b-button
            style="flex: 1"
            @click="filterData(1)"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
            :disabled="dataLoading"
          >
            <span class="align-middle">{{ $t("Show") }}</span>
          </b-button>
        </b-col>
        <!-- <b-col xl="2" lg="3" md="4" cols="12">
          <b-button
            @click="filterData()"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1 mb-md-0"
          >
            <span class="align-middle">Show</span>
          </b-button>
        </b-col> -->
      </b-row>

      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @change="filterData()"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>

      <b-table
        class="mt-1 rotate-table"
        ref="selectableTable"
        :items="items"
        :fields="fields"
        :busy="dataLoading"
        responsive
        show-empty
        hover
        :selectable="rights.edit"
        select-mode="single"
        @row-selected="Edit($event[0])"
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <template #cell(voucherNum)="data">
          <b-badge variant="light-primary" class="mb-50">
            {{ data.item.entry.voucherType }}
          </b-badge>
          <br />
          <b-badge variant="light-primary">
            {{ data.item.entry.voucherNum }}
          </b-badge>
        </template>
        <template #cell(date)="data">
          <b-badge variant="light-primary">
            {{
              new Date(data.item.entry.date).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </b-badge>
          <br />
          <b-badge
            :variant="getVariant(data.item.entry.status)"
            class="mt-50"
            v-if="data.item.entry.status && data.item.entry.status != 'active'"
          >
            {{ $t(data.item.entry.status) }}
          </b-badge>
        </template>
        <template #cell(supplier)="data">
          <b-badge variant="light-primary">
            {{ data.item.supplier }}
          </b-badge>
        </template>
        <template #cell(account)="data">
          <div v-for="rec in data.item.details" :key="rec">
            <b-badge variant="light-primary" class="mb-50">
              {{ rec.meta_accountTitle }}
            </b-badge>
          </div>
        </template>
        <template #cell(debit)="data">
          <div v-for="rec in data.item.details" :key="rec">
            <b-badge variant="light-primary" class="mb-50">
              {{ rec.debit }}
            </b-badge>
          </div>
          <div class="border-top-secondary pt-50">
            <label class="font-weight-bold mr-50">{{ $t("Total") }}:</label>
            <b-badge variant="light-primary" class="">
              {{ debitTotal(data.item.details) }}
            </b-badge>
          </div>
        </template>
        <template #cell(credit)="data">
          <div v-for="rec in data.item.details" :key="rec">
            <b-badge variant="light-primary" class="mb-50">
              {{ rec.credit }}
            </b-badge>
          </div>
          <div class="border-top-secondary pt-50">
            <label class="font-weight-bold mr-50">{{ $t("Total") }}:</label>
            <b-badge variant="light-primary" class="">
              {{ creditTotal(data.item.details) }}
            </b-badge>
          </div>
        </template>
        <template #cell(chequeNo)="data">
          <div v-for="rec in data.item.details" :key="rec">
            <b-badge variant="light-primary" class="mb-50">
              {{ rec.chequeNo }}
            </b-badge>
          </div>
        </template>
        <template #cell(note)="data">
          <div v-for="rec in data.item.details" :key="rec">
            <b-badge variant="light-primary" class="mb-50">
              {{ rec.description }}
            </b-badge>
          </div>
        </template>

        <template #head()="scope">
          <div :class="scope.label == 'actions' && 'text-center'">
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="d-flex">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-50"
              @click="Edit(data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              v-if="
                rights.review &&
                data.item.entry.status &&
                data.item.entry.status == 'under review'
              "
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-success"
              v-b-tooltip.hover.left
              :title="$t('Move to Pending')"
              class="btn-icon mr-50"
              @click="updateEntry(data.item.entry)"
            >
              <feather-icon icon="CheckIcon" class="" />
            </b-button>

            <template v-if="data.item.entry.status == 'approved'">
              <b-dropdown
                v-if="bankVisible.includes(reportDomain)"
                :title="$t('Print Cheque')"
                v-b-tooltip.hover.left
                no-caret
                :right="$store.state.appConfig.isRTL"
                class="mr-50"
                toggle-class="btn-icon"
                variant="primary"
              >
                <template #button-content>
                  <feather-icon icon="PrinterIcon" />
                </template>

                <b-dropdown-item
                  v-for="(dd, ind) in bankOptions"
                  :key="ind"
                  @click="print(data.item.entry.id, dd.value)"
                >
                  <span class="align-middle text-capitalize">
                    {{ $t(dd.name) }}
                  </span>
                </b-dropdown-item>
              </b-dropdown>

              <b-button
                v-else
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.left
                :title="$t('Print Cheque')"
                class="btn-icon mr-50"
                @click="print(data.item.entry.id, '')"
              >
                <feather-icon icon="PrinterIcon" class="" />
              </b-button>
            </template>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Print Voucher')"
              class="btn-icon mr-50"
              @click="printVoucher(data.item.entry.id)"
            >
              <feather-icon icon="FileTextIcon" class="" />
            </b-button>

            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon"
              @click="Delete(data.item.entry.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

import { mapActions, mapGetters } from "vuex";
import roleCoaAccessMixin from "@/mixins/roleCoaAccessMixin";
import { syncAccountCoaRestrictionsToStore } from "@/utils/roleCoaAccess";

export default {
  mixins: [roleCoaAccessMixin],
  components: {
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    flatPickr,
    vSelect,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    syncAccountCoaRestrictionsToStore(
      this.$store,
      this.$store.state.loggedUser?.forms
    );
    const priorRights = { ...(this.$store.state.rights || {}) };
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          hideFee: ch.hideFee,
          review: ch.review,
          disableDate: ch.disableDate,
          coaAccountIDs:
            ch.coaAccountIDs || priorRights[ch.route]?.coaAccountIDs || [0],
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", { ...priorRights, ...right });

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      // this.LoadData();
      // this.filterData();
      this.LoadSettingsAll();
    }
  },
  computed: {
    filters: function () {
      const searchTerm = this.searchQuery.toLowerCase();

      return this.items.filter((pro) => {
        const voucherMatch =
          pro.entry.voucherType &&
          pro.entry.voucherNum &&
          (`${pro.entry.voucherType} ${pro.entry.voucherNum}`
            .toLowerCase()
            .includes(searchTerm) ||
            `${pro.entry.voucherType}${pro.entry.voucherNum}`
              .toLowerCase()
              .includes(searchTerm));

        // Search in descriptions of all detail items
        const descriptionMatch =
          pro.details &&
          pro.details.some(
            (detail) =>
              detail.description &&
              detail.description.toString().toLowerCase().includes(searchTerm)
          );

        return voucherMatch || descriptionMatch;
      });
    },
  },
  data() {
    return {
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      searchDate: "",
      dtObj: {
        dtFrom: null,
        dtTo: null,
      },
      rights: {},
      dataLoading: false,
      searchQuery: "",
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      fields: [
        { label: "Voucher#", key: "voucherNum", tdClass: "setCell" },
        { label: "date", key: "date", tdClass: "setCell" },
        // { label: "supplier", key: "supplier", tdClass: "setCell" },
        { label: "account", key: "account", tdClass: "setCell" },
        { label: "debit", key: "debit" },
        { label: "credit", key: "credit" },
        { label: "cheque#", key: "chequeNo", tdClass: "setCell" },
        { label: "note", key: "note", tdClass: "setCell" },
        { label: "actions", key: "actions", tdClass: "setCell p-1" },
      ],
      items: [],
      filteredJournalCache: [],
      filteredJournalCacheKey: "",
      statusOptions: [
        { text: "All", value: "" },
        { text: "Pending", value: "pending" },
        { text: "Approved", value: "approved" },
        { text: "Declined", value: "declined" },
      ],
      filterStatus: this.$store.state.journalStatus,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      bankVisible: ["myskoolelixir"],
      bankOptions: [
        { name: "Dubai Islamic Bank", value: "" },
        { name: "Bank Al Habib", value: "al-habib" },
        { name: "Faysal Bank", value: "faysal" },
      ],
      reviewObj: null,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getVariant(status) {
      const vt =
        status == "approved"
          ? "success"
          : status == "under review"
          ? "warning"
          : "danger";
      return `light-${vt}`;
    },
    print(id, bank) {
      var url =
        `https://${this.reportDomain}.myskool.app/Account/PrintCheque?entryID=` +
        id +
        "&dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&title=cash" +
        "&bank=" +
        bank;

      window.open(url, "_blank");
    },

    printVoucher(id) {
      var url =
        `https://${this.reportDomain}.myskool.app/Account/PrintEntryVoucher?entryID=` +
        id +
        "&dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId;

      window.open(url, "_blank");
    },

    creditTotal(items) {
      let total = items.reduce(
        (sum, el) => (el.credit ? sum + el.credit : sum + 0),
        0
      );
      return total;
    },
    debitTotal(items) {
      let total = items.reduce(
        (sum, el) => (el.debit ? sum + el.debit : sum + 0),
        0
      );
      return total;
    },

    async LoadSettingsAll() {
      this.dataLoading = true;

      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["journal_entry_review"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.reviewObj = res.find((el) => el.key == "journal_entry_review");
      if (this.reviewObj?.valueBool) {
        this.statusOptions.splice(1, 0, {
          text: "Under Review",
          value: "under review",
        });
        // load under review if user has review right
        if (this.rights.review) {
          this.filterStatus = "under review";
          this.setStatus();
        }
      } else if (this.filterStatus == "under review") {
        // reset to all if no review setting and last selected was under review
        this.filterStatus = "";
        this.setStatus();
      }
      await this.loadRoleCoaAccessSetting();
      this.filterData();
    },

    async Edit(item) {
      const route =
        this.reportDomain == "myskoolhpgs"
          ? "accounting-project"
          : "accounting";

      if (item == 0) {
        this.$router.push({ name: route, params: { id: 0 } });
      } else {
        // console.log(item);
        this.$router.push({
          name: route,
          params: { id: item.entry.id, data: item },
        });
      }
    },

    journalListQueryKey() {
      return JSON.stringify({
        status: this.filterStatus,
        dtFrom: this.dtObj.dtFrom,
        dtTo: this.dtObj.dtTo,
        coa: this.coaAccountIdsQueryParam(),
      });
    },

    buildJournalListRequest(page) {
      const suffix = this.coaAccountIdsQueryParam();
      const url =
        this.filterStatus !== ""
          ? this.$store.state.domain +
            "JournalEntry/LoadDataByStatusPagination?cID=" +
            this.$store.state.userData.cId +
            "&db=" +
            this.$store.state.userData.db +
            "&status=" +
            this.filterStatus +
            "&page=" +
            page +
            suffix
          : this.$store.state.domain +
            "JournalEntry/LoadDataPagination?cID=" +
            this.$store.state.userData.cId +
            "&db=" +
            this.$store.state.userData.db +
            "&dtFrom=" +
            (this.dtObj.dtFrom || "") +
            "&dtTo=" +
            (this.dtObj.dtTo || "") +
            "&page=" +
            page +
            suffix;

      return {
        url,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
    },

    applyJournalListFilters(data) {
      if (!Array.isArray(data)) return [];
      return this.filterJournalEntriesByRole(data);
    },

    paginateFilteredJournalCache() {
      const list = this.filteredJournalCache || [];
      const start = (this.currentPage - 1) * this.perPage;
      this.items = list.slice(start, start + this.perPage);
      this.totalRows = list.length;
    },

    async fetchAllJournalRowsForQuery() {
      const API_PAGE_SIZE = 50;
      let page = 1;
      let allRaw = [];
      while (true) {
        const res = await this.get(this.buildJournalListRequest(page));
        if (Array.isArray(res)) break;
        const chunk = res.data || [];
        allRaw = allRaw.concat(chunk);
        if (chunk.length < API_PAGE_SIZE) break;
        page += 1;
        if (page > 500) break;
      }
      return allRaw;
    },

    async refreshJournalListCoaMode() {
      this.dataLoading = true;
      try {
        const allRaw = await this.fetchAllJournalRowsForQuery();
        this.filteredJournalCache = this.applyJournalListFilters(allRaw);
        this.filteredJournalCacheKey = this.journalListQueryKey();
        this.paginateFilteredJournalCache();
      } finally {
        this.dataLoading = false;
      }
    },

    async refreshJournalListServerPage() {
      this.dataLoading = true;
      try {
        const res = await this.get(
          this.buildJournalListRequest(this.currentPage)
        );
        if (!Array.isArray(res)) {
          const data = this.applyJournalListFilters(res.data || []);
          this.items = data;
          this.totalRows = res.total || data.length;
        } else {
          this.items = [];
          this.totalRows = 0;
        }
      } finally {
        this.dataLoading = false;
      }
    },

    async LoadData() {
      if (this.hasCoaJournalRestriction()) {
        await this.refreshJournalListCoaMode();
      } else {
        await this.refreshJournalListServerPage();
      }
    },

    setStatus() {
      this.$store.commit("setJournalStatus", this.filterStatus);
    },
    setDate(sd, dateStr) {
      // console.log(sd, dateStr);
      if (dateStr) {
        if (sd.length > 1) {
          let date = dateStr.split(" to ");
          if (date.length == 1) {
            this.dtObj.dtFrom = date[0];
            this.dtObj.dtTo = date[0];
          } else {
            this.dtObj.dtFrom = date[0];
            this.dtObj.dtTo = date[1];
          }
        } else {
          this.dtObj.dtFrom = dateStr;
          this.dtObj.dtTo = null;
        }
      } else {
        this.dtObj.dtFrom = null;
        this.dtObj.dtTo = null;
      }
      // console.log(this.dtObj);
    },

    async filterData(val) {
      this.$nextTick(async () => {
        if (val === 1) this.currentPage = 1;

        if (this.hasCoaJournalRestriction()) {
          const key = this.journalListQueryKey();
          if (
            !val &&
            key === this.filteredJournalCacheKey &&
            this.filteredJournalCache.length >= 0
          ) {
            this.paginateFilteredJournalCache();
            return;
          }
          await this.refreshJournalListCoaMode();
          return;
        }

        if (
          this.filterStatus === "" &&
          !this.dtObj.dtFrom &&
          !this.dtObj.dtTo
        ) {
          await this.LoadData();
        } else {
          await this.refreshJournalListServerPage();
        }
      });
    },

    async LoadSearch() {
      if (this.searchQuery.trim() == "") {
        this.filterData(1);
      } else {
        this.dataLoading = true;
        var obj = {
          url:
            this.$store.state.domain +
            "JournalEntry/Search?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&keyword=" +
            this.searchQuery.trim(),
          token: this.$store.state.userData.token,
        };
        const res = await this.get(obj);
        const list = Array.isArray(res) ? res : res?.data || [];
        this.items = this.applyJournalListFilters(list);
        this.totalRows = this.items.length;
        this.filteredJournalCache = [];
        this.filteredJournalCacheKey = "";
        this.currentPage = 1;
        this.dataLoading = false;
      }
    },

    async updateEntry(item) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        let obj = { ...item };
        obj.status = "pending";
        var status = await this.put({
          url:
            this.$store.state.domain +
              "JournalEntry/" +
              obj.id +
              "?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
          message: "Journal updated successfully!",
          context: this,
          body: obj,
          token: this.$store.state.userData.token,
        });
        if (status) this.filterData();
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        // console.log(id);
        var status = await this.delete({
          url:
            this.$store.state.domain +
              "JournalEntry/DeleteVoucher?cID=" +
              this.$store.state.userData.cId +
              "&db=" +
              this.$store.state.userData.db +
              "&id=" +
              id +
              "&userID=" +
              this.$store.state.userData.userID,
          message: "Journal deleted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.filterData();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.rotate-table.table-responsive {
  transform: rotateX(180deg);
}
.rotate-table.table-responsive > ::v-deep.table {
  transform: rotateX(180deg);
}
</style>
